import { render, staticRenderFns } from "./Undervisningstimer.vue?vue&type=template&id=4b532696&"
import script from "./Undervisningstimer.vue?vue&type=script&lang=ts&"
export * from "./Undervisningstimer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports